import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

interface CatalogResultsHeaderProps {
  count: number;
  query: string;
}

/**
 * Sticky section header for catalog search results.
 * Displays 'catalog results: N "query"' below the column headers.
 */
export const CatalogResultsHeader: React.FC<CatalogResultsHeaderProps> = ({
  count,
  query,
}) => {
  const [styles] = useStyles();

  return (
    <View style={styles.container}>
      <Typography variant="heading-sm">
        {i18n.t('sales_portal.order_entry.catalog_results_header', {
          count,
          query,
        })}
      </Typography>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    backgroundColor: theme.sk.color.bg.primary.default,
    paddingBottom: theme.sk.spacing.spaceXsmall,
    paddingHorizontal: theme.sk.spacing.spaceMedium,
    paddingTop: theme.sk.spacing.spaceMedium,
  },
}));
